import * as React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Form, Formik, FieldArray, Field } from "formik";
import styled, { css } from "styled-components";
import uniq from "lodash/uniq";
import { IfPermitted, Icon, ModalSubmit } from "components/common";
import { Button, Input, Modal, Table } from "components/bootstrap";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
const LabelSpan = styled.span(
  ({ theme }) => css`
    margin-left: ${theme.spacings.sm};
    font-weight: bold;
  `
);
const StyledTable = styled(Table)`
  margin-top: 10px;
`;
const TrafficLimitViolationConfigForm = ({ saveConfig, recipients }) => {
  const { t } = useTranslation("enterprise_license");
  const [showModal, setShowModal] = useState(false);
  const sendTelemetry = useSendTelemetry("traffic-limi-violation");
  const _resetConfig = () => {
    setShowModal(false);
  };
  const _saveConfig = (config) => {
    const updatedConfig = { email_recipients: uniq(config.email_recipients) };
    saveConfig(updatedConfig);
    sendTelemetry(TELEMETRY_EVENT_TYPE.TRAFFIC_VIOLATION_CONFIGURATION_SAVED, {
      app_pathname: "configurations"
    });
    setShowModal(false);
  };
  const modalTitle = t("traffic_violation.configure_title");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "clusterconfigentry:edit" }, /* @__PURE__ */ React.createElement(
    Button,
    {
      type: "button",
      bsSize: "xs",
      bsStyle: "info",
      onClick: () => {
        setShowModal(true);
      }
    },
    t("traffic_violation.edit_configuration")
  )), /* @__PURE__ */ React.createElement(Modal, { show: showModal, onHide: _resetConfig }, /* @__PURE__ */ React.createElement(Formik, { onSubmit: _saveConfig, initialValues: { email_recipients: recipients } }, ({ isSubmitting, values }) => /* @__PURE__ */ React.createElement(Form, null, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, modalTitle)), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement(
    FieldArray,
    {
      name: "email_recipients",
      render: (arrayHelpers) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledTable, { bordered: true }, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "#"), /* @__PURE__ */ React.createElement("th", null, t("traffic_violation.email")))), /* @__PURE__ */ React.createElement("tbody", null, values.email_recipients && values.email_recipients.map((email, idx) => (
        // eslint-disable-next-line react/no-array-index-key
        /* @__PURE__ */ React.createElement("tr", { key: idx }, /* @__PURE__ */ React.createElement("td", { style: { verticalAlign: "middle", textAlign: "center" } }, idx + 1), /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(Field, { name: `email_recipients[${idx}]`, value: email }, ({ field, meta }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
          Input,
          {
            id: `email-${idx}`,
            name: field.name,
            value: field.value,
            onChange: field.onChange,
            bsStyle: meta.touched && meta.error ? "error" : null,
            onBlur: field.onBlur,
            type: "email",
            required: true
          }
        ), meta.touched && meta.error && /* @__PURE__ */ React.createElement(LabelSpan, null, t("traffic_violation.invalid_email", { email: field.value }))))), /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(Button, { bsStyle: "danger", onClick: () => arrayHelpers.remove(idx) }, /* @__PURE__ */ React.createElement(Icon, { name: "delete" }))))
      )))), /* @__PURE__ */ React.createElement(Button, { type: "button", onClick: () => arrayHelpers.push("") }, t("traffic_violation.add_recipient")))
    }
  )), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(
    ModalSubmit,
    {
      onCancel: _resetConfig,
      isSubmitting,
      isAsyncSubmit: true,
      submitButtonText: t("traffic_violation.update_configuration"),
      submitLoadingText: t("traffic_violation.updating_configuration")
    }
  ))))));
};
export default TrafficLimitViolationConfigForm;
